export default (axios, { email, lang }) => axios.post('/restore', { email, lang });
